const ItsYourLove = [
	'[Verse 1]',
	'Dancing in the dark, middle of the night',
	'Taking your heart, and holding it tight',
	'Emotional touch, touching my skin',
	'And asking you to do what you been doing all over again',
	'',
	'[Pre-chorus]',
	"Ohhhh, it's a beautiful thing, don't think I can keep it all in",
	"I just got to let you know, what it is that won't let me go",
	'',
	'[Chorus]',
	"It's your love,",
	'it just does something to me',
	'It sends a shock right through me,',
	"I can't get enough",
	"And if you wonder about the spell I'm under",
	"Oh, it's your love",
	'',
	'[Verse 2]',
	'Better than I was, and more than I am',
	'And all of this happened, by taking your hand',
	'And who I am now, is who I wanted to be',
	"And now that were together I'm stronger than ever, I'm happy and free",
	'',
	'[Pre-chorus]',
	"Ohhhh, it's a beautiful thing, don't think I can keep it all in",
	"And if you ask me why I've changed all I got to do is say your sweet name",
	'',
	'[Chorus]',
	"It's your love,",
	'it just does something to me',
	'It sends a shock right through me,',
	"I can't get enough",
	"And if you wonder, about the spell I'm under",
	"Oh, it's your love",
	'',
	'[Pre-chorus]',
	"Ohhhh, it's a beautiful thing,",
	"don't think I can keep it all in",
	"I just got to let you know what it is that won't let me go",
	'',
	'[Chorus]',
	"It's your love,",
	'it just does something to me',
	'It sends a shock right through me,',
	"I can't get enough",
	"And if you wonder about the spell I'm under",
	"Oh it's your love",
	'',
	'[Outro]',
	"It's your love",
	"It's your love",
	"It's your love",
];

export default ItsYourLove;
